import {
  ChildrenType,
  DisabledType,
  FormJSState,
  HiddenType,
  LabelType,
  ReadonlyType,
  TitleType,
  ValueType,
} from '@smartsheet-dataflow/formjs';
import { ComponentType } from '@smartsheet-dataflow/formjs-react';
import {
  ArrayItemsLabelState,
  ErrorState,
  IsOpenState,
  LinkState,
  SchemaState,
} from './features';

interface AllFeaturesState {
  children: {
    [inputId: string]: ChildrenType;
  };
  disabled: {
    [inputId: string]: DisabledType;
  };
  hidden: {
    [inputId: string]: HiddenType;
  };
  label: {
    [inputId: string]: LabelType;
  };
  readonly: {
    [inputId: string]: ReadonlyType;
  };
  title: {
    [inputId: string]: TitleType;
  };
  value: {
    [inputId: string]: ValueType;
  };
}

interface ComponentState {
  component: {
    [inputId: string]: ComponentType;
  };
}

interface HideExpressionState {
  hideExpression: {
    [path: string]: string;
  };
}

export type BridgeFormJSState = FormJSState<
  Omit<AllFeaturesState, 'disabled'> &
    ComponentState &
    SchemaState &
    HideExpressionState &
    LinkState &
    IsOpenState &
    ErrorState &
    ArrayItemsLabelState
>;

export const DEFAULT_STATE: BridgeFormJSState = {
  value: {},
  title: {},
  label: {},
  readonly: {},
  hidden: {},
  schema: {},
  children: {
    form: [],
  },
  component: {
    form: 'GROUP',
  },
  hideExpression: {},
  link: {},
  isOpen: {},
  error: {},
  arrayItemsLabel: {},
};
